import * as PopupActionTypes from '../constants/common/PopupActionTypes';
export const showCommentReplyPopup = (commentId) => ({
    type: PopupActionTypes.SHOW_COMMENT_REPLY_POPUP,
    commentId
});

export const showCommentBlockPopup = (commentId) => ({
    type: PopupActionTypes.SHOW_COMMENT_BLOCK_POPUP,
    commentId
});

export const showSkinSavePopup = (title, description, callBack) => ({
    type: PopupActionTypes.SHOW_SKIN_ADD_POPUP,
    title,
    description,
    callBack
});

export const showSkinDetailPopup = (skin) => ({
    type: PopupActionTypes.SHOW_SKIN_DETAIL_POPUP,
    skin
});

export const showEditSidebarModulePopup = (module) => ({
    type: PopupActionTypes.SHOW_EDIT_SIDEBAR_MODULE_POPUP,
    module,
});

export const showErrorToastPopup = (title, description) => ({
    type: PopupActionTypes.SHOW_ERROR_TOAST_POPUP,
    title,
    description
});

export const showLoadingPopup = (loadingPopupMessage) => ({
    type: PopupActionTypes.SHOW_LOADING_POPUP,
    loadingPopupMessage
});

export const hideLoadingPopup = () => ({
    type: PopupActionTypes.HIDE_LOADING_POPUP,
});

export const closePopup = () => ({
    type: PopupActionTypes.CLOSE_POPUP,
});

export const showClearDataResultPopup = (resultCode, resultMessage) => ({
    type: PopupActionTypes.SHOW_CLEAR_DATA_RESULT_POPUP,
    resultCode,
    resultMessage,
});

export const showCloseBlogResultPopup = (resultCode, resultMessage) => ({
    type: PopupActionTypes.SHOW_CLOSE_BLOG_RESULT_POPUP,
    resultCode,
    resultMessage,
});

export const showMovingCategoryPopup = (category) => ({
    type: PopupActionTypes.SHOW_MOVING_CATEGORY_POPUP,
    category,
});
